import React from 'react'
import dinoSkelly from "../assets/dino-skelly.png";
import Footer from './Footer';


function End() {
  return (
    <div className=' End CPIntro flex justify-center  
    mt-[-12px] pt-48 pb-56 h-screen ' >
        <img className='w-60  lg:w-[700px] object-contain' src={dinoSkelly} alt="" />
    </div>
  )
}

export default End 